import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Pagination from 'components/Libs/Pagination';

import { searchArea } from 'actions/regions/areas';

import styles from 'styles';

import AreasAltNamesRow from './Row';

class AreasAltNamesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            areas: [],
        };

        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    filterSearch(searchArray, searchText) {
        if (searchText === '') {
            return searchArray;
        }

        searchText = searchText.toLowerCase();

        return searchArray.filter((item) => {
            if (item.prevState.name) {
                if (item.prevState.name.toLowerCase().includes(searchText)) {
                    return true;
                }
            }

            for (let i = 0; i < item.prevState.alt.length; i++) {
                if (item.prevState.alt[i].toLowerCase().includes(searchText)) {
                    return true;
                }
            }

            return false;
        });
    }

    handleSearch(e, value) {
        this.props.searchArea(value.toLowerCase());
    }

    makeFilter(props) {
        let page = this.state.page;

        if (props.searchText !== this.state.searchText) {
            page = 1;
        }

        const areas = this.filterSearch(props.areas, props.searchText);

        this.setState({
            searchText: props.searchText,
            areas,
            page,
            total: props.areas.length,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.areas.length) {
            this.makeFilter(props);
        }
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.areas.slice(from, to);
    }

    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;

        this.setState(state);
    }

    render() {
        const { searchText } = this.props;
        const { rows } = this.state;

        let renderSuggestions = (<div className='port-suggestions'>
            <div className='title'>This name has been already used:</div>
            <div className='content'>
                {
                    this.props.suggestionsAreas.map((area) => {
                        return area.alt ? ` ${area.name} - (${area.alt.join(', ')}), ` : `${area.name}, `;
                    })
                }
            </div>
        </div>);

        let renderPagination = (<Pagination
            total={this.state.areas.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            numberOfRows={this.state.numberOfRows}
            updateRows={this.handleUpdateRow}
        />);

        let renderTable = (<Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        name area
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        alt
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        {null}
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>

            <TableBody displayRowCheckbox={false}>
                {
                    rows.map((row) => {
                        return (<AreasAltNamesRow key={row._id} item={row} />);
                    })
                }
            </TableBody>
        </Table>);

        if (!this.props.suggestionsAreas.length) {
            renderSuggestions = null;
        }

        if (!rows.length) {
            renderTable = (<div className='nothing-found'>Not found</div>);
            renderPagination = null;
        }

        return (
            <div>
                <div className='table-header'>
                    <div className='item'>
                        <TextField
                            defaultValue={searchText}
                            floatingLabelText='Search'
                            onChange={this.handleSearch}
                        />
                    </div>

                    <div className='item'>
                        {renderPagination}
                    </div>
                </div>

                {renderSuggestions}

                <div className='table-body'>
                    {renderTable}
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            searchText: state.areas.searchText,
            areas: state.areas.items,
            suggestionsAreas: state.areas.suggestions,
        };
    },
    dispatch => bindActionCreators({
            searchArea
    },
    dispatch),
)(AreasAltNamesTable);



// WEBPACK FOOTER //
// ./app/components/Regions/AreasAltNames/Table.jsx